import { create as n } from "zustand";
import { devtools as d } from "zustand/middleware";
import { produce as t } from "immer";
const v = n()(
  d(
    (c, p) => ({
      maps: {},
      actions: {
        initMapStore: ({ mapId: e }) => {
          const r = p().maps;
          if (r && r[e]) {
            console.warn(
              `Map ID: ${e} already exists within the usePLMapboxDeckStore`
            );
            return;
          }
          c(
            t((a) => {
              a.maps[e] = {
                deckLayers: {},
                deckOverlaidLayers: {},
                deckRef: void 0,
                deckOverlaidRef: void 0
              };
            }),
            !1,
            `initMapStore - ${e}`
          );
        },
        resetMapStore: ({ mapId: e }) => {
          c(
            t((r) => {
              r.maps[e].deckLayers = {}, r.maps[e].deckOverlaidLayers = {};
            }),
            !1,
            `resetMapStore - ${e}`
          );
        },
        deleteMapStore: (e) => {
          c(
            t((r) => {
              delete r.maps[e];
            }),
            !1,
            `deleteMapStore - ${e}`
          );
        },
        setDeckRef: ({ mapId: e, interleaved: r, deckRef: a }) => {
          c(
            t((s) => {
              r ? s.maps[e].deckRef = a : s.maps[e].deckOverlaidRef = a;
            }),
            !1,
            `setDeckRef - ${e}`
          );
        },
        isMapStoreLoaded: (e) => {
          var a;
          return !!((a = p().maps) == null ? void 0 : a[e]);
        },
        updateDeckLayer: ({ mapId: e, layerId: r, deckLayer: a }) => {
          c(
            t((s) => {
              s.maps[e].deckLayers[r] = a;
            }),
            !1,
            "updateDeckLayer"
          );
        },
        updateDeckOverlaidLayer: ({ mapId: e, layerId: r, deckLayer: a }) => {
          c(
            t((s) => {
              s.maps[e].deckOverlaidLayers[r] = a;
            }),
            !1,
            "updateDeckLayer"
          );
        },
        removeAllDeckLayersConnectingToLayerId: ({ mapId: e, layerId: r }) => {
          c(
            t((a) => {
              var l, k;
              if (!((k = (l = a.maps) == null ? void 0 : l[e]) != null && k.deckLayers))
                return;
              const s = Object.keys(
                a.maps[e].deckLayers
              ).reduce((i, o) => (o.includes(r) || (i[o] = a.maps[e].deckLayers[o]), i), {});
              a.maps[e].deckLayers = s;
              const L = Object.keys(
                a.maps[e].deckOverlaidLayers
              ).reduce((i, o) => (o.includes(r) || (i[o] = a.maps[e].deckOverlaidLayers[o]), i), {});
              a.maps[e].deckOverlaidLayers = L;
            }),
            !1,
            ` removeAllDeckLayersConnectingToLayerId-${r}`
          );
        }
      }
    }),
    {
      name: "PLMapboxDeckStore",
      enabled: !1
    }
  )
);
export {
  v as usePLMapboxDeckStore
};
//# sourceMappingURL=index.es23.js.map
